import React, { useState } from 'react';
import { Row, Button, InlineEditColumnProps, FormInput, InlineEditTable, MasterDetailForm, Widget } from '@digital/ui';
import { TipoPacote, TPData } from '@app/api/tipoPacote';
import { Input, Icon, Collapse } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { ServicoPrazo } from '@app/api/servicoPrazo';

interface ServicoPrazoProps {
  titulo: string;
  label: string;
  data: ServicoPrazo[];
  handleUpdate: (record: ServicoPrazo) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
}

const ServicoPrazoComponent = (props: ServicoPrazoProps) => {
  const { titulo, label, data, handleUpdate, shouldUpdate } = props;

  const customColumns = () => {
    return [
      {
        title: 'Codigo',
        dataIndex: 'codigo',
        width: '10%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '60%',
      },
      {
        title: 'Prazo',
        dataIndex: 'prazo',
        width: '30%',
        renderEdit: () => <FormInput name="prazo" disabled={false} required />,
      },
    ] as InlineEditColumnProps<ServicoPrazo>[];
  };

  const { Panel } = Collapse;

  const handlePrazoUpdate = async (record: ServicoPrazo) => {
    const result = await handleUpdate(record)
    shouldUpdate(result)
    return result
  }

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="1" header={titulo} style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[]}>
              <Row>
                <InlineEditTable
                  rowKey="tipoPacoteId"
                  columns={customColumns()}
                  updateItem={hasPermission(['ACRONIMOS_EDITAR']) ? handlePrazoUpdate : async () => { return false }}
                  dataSource={data}
                  pagination={false}
                  disablenotification={false}
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default ServicoPrazoComponent;
